import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { WebService } from '../../services/webService';
import Swal from 'sweetalert2';

const Blog = () => {

   const [blog,setBlog] = useState();

const getBlog = async () => {
   try {
      const data = await WebService.getBlogHome();
      setBlog(data || []);
   } catch (error) {
      Swal.fire({
         icon: "error",
         title: "Error!",
         text: "No se pudo cargar la información del blog",
         confirmButtonColor: "#147B9C",
      });
   }
};
   useEffect(() => {
      getBlog();
   }, []);

   return (
      <>
         <div className="section animated fadeIn">
            <div className="container">
               
               {/* TÍTULO DE LA SECCIÓN INSTITUCIONAL (Opcional pero suma orden) */}
               <div className="row mb-title center" style={{ marginBottom: '35px' }}>
                  <div className="col s12">
                     <h4 className="light-blue-text text-accent-3 institutional-title" style={{ fontWeight: '600' }}>
                        ACTUALIDAD Y PREVENCIÓN
                     </h4>
                     <p className="grey-text text-darken-1" style={{ fontSize: '1.05rem' }}>
                        Novedades, consejos de seguridad laboral y prevención de riesgos
                     </p>
                  </div>
               </div>

               {/* GRILLA DE TARJETAS */}
               <div className="row">
                  {blog?.map((b, index) => {
                     return(
                        <div className="col s12 m4 l4 x4" key={index}>
                           <div className="card hoverable" style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#fff', transition: 'all 0.3s ease' }}>
                              
                              {/* CONTENEDOR DE IMAGEN CON ALTURA FIJA */}
                              <div className="card-image" style={{ height: '210px', overflow: 'hidden', backgroundColor: '#f5f5f5' }}>
                                 <img 
                                    src={`/app.latitud/img/blog/${b.blog_img}`} 
                                    alt={b.blog_titulo}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                 />
                              </div>

                              {/* CONTENIDO DE LA TARJETA */}
                              <div className="card-content" style={{ padding: '20px', flexGrow: '1', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                 <div>
                                    <span style={{ color: '#039be5', fontSize: '0.8rem', fontWeight: '700', textTransform: 'uppercase', display: 'block', marginBottom: '8px', letterSpacing: '0.5px' }}>
                                       {b.blog_etiqueta}
                                    </span>
                                    <h6 style={{ color: '#333', fontWeight: '600', fontSize: '1.05rem', lineHeight: '1.4', margin: '0' }}>
                                       {b.blog_titulo}
                                    </h6>
                                 </div>
                              </div>

                           </div>
                        </div>
                     )
                  })}
               </div>

               {/* BOTÓN "LEER MÁS" */}
               <div className="row center" style={{ marginTop: '30px' }}>
                  <Link 
                     to={"blog"} 
                     className="btn waves-effect waves-light light-blue accent-3 z-depth-1 hoverable" 
                     style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 32px', height: '46px', lineHeight: '46px' }}
                  >
                     Ver más publicaciones
                     <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '6px' }}>arrow_forward</i>
                  </Link>
               </div>

            </div>
         </div>

      </>
   )
}

export default Blog